import { useMutation } from "@tanstack/react-query";

import { ProjectsCreateRequest } from "@/api";
import getTbiApi from "@/api/api-v1";
import { useOnError } from "@/utils/on-error";

import { useUpdateProjectQueries } from "./query-projects";

// Stupid bug in the API generator where it omits "createdAt" as "created_at", so we add it ourselves
export type ActualProjectCreateRequest = {
  project: Omit<ProjectsCreateRequest["project"], "createdAt" | "updatedAt" | "organisationName">;
};

export function useCreateProject() {
  const updateProjectQueries = useUpdateProjectQueries();
  const onError = useOnError(
    "Project maken mislukt. Probeer de project naam te veranderen of later opnieuw."
  );
  return useMutation({
    mutationFn: async (createRequest: ActualProjectCreateRequest) => {
      const response = await getTbiApi().ProjectsApi.projectsCreate(
        createRequest as ProjectsCreateRequest
      );

      updateProjectQueries(response);

      return response;
    },
    onError,
  });
}

export function useRestartProject() {
  const updateProjectQueries = useUpdateProjectQueries();
  const onError = useOnError(
    "Project maken mislukt. Probeer de project naam te veranderen of later opnieuw."
  );
  return useMutation({
    mutationFn: async (slug: string) => {
      const response = await getTbiApi().ProjectsApi.projectsPartialUpdate({ slug });

      await updateProjectQueries(response);

      return response;
    },
    onError,
  });
}
